export default __webpack_public_path__ + "static/media/team_03.746caa31.png";